// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   PROJECT PERFORMANCE & ANALYTICS REPORTS STYLING
   Enterprise Linear/Stripe/Vercel Aesthetic
   ========================================================================== */

/* ── Hero / Overview Header ────────────────────────────────────────────── */
.reports-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.reports-hero-left {
    flex: 1 1;
    min-width: 280px;
}

.reports-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.reports-hero-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.reports-hero-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px 0;
    max-width: 600px;
    line-height: 1.5;
}

.reports-meta-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.report-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.report-chip i {
    font-size: 12px;
    color: #6366f1;
}

.report-chip-status {
    background: #ecfdf5;
    border-color: #a7f3d0;
    color: #065f46;
}

.pulse-dot-green {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #10b981;
    display: inline-block;
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
    animation: pulseGlow 1.8s infinite;
}

@keyframes pulseGlow {
    0% {
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
    }

    70% {
        box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
    }
}

/* ── Hero Actions ──────────────────────────────────────────────────────── */
.reports-hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-report-action {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.btn-report-action:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #0f172a;
    transform: translateY(-1px);
}

.btn-report-action.btn-primary-gradient {
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
    color: #ffffff;
    border: 1px solid #4338ca;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
}

.btn-report-action.btn-primary-gradient:hover {
    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%);
    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);
    transform: translateY(-1px);
}

/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */
.reports-kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

@media (max-width: 1200px) {
    .reports-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .reports-kpi-grid {
        grid-template-columns: 1fr;
    }
}

.rep-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    transition: all 0.25s ease;
}

.rep-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.rep-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.rep-kpi-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #64748b;
}

.rep-kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.rep-icon-purple {
    background: #f5f3ff;
    color: #7c3aed;
}

.rep-icon-emerald {
    background: #ecfdf5;
    color: #10b981;
}

.rep-icon-amber {
    background: #fffbeb;
    color: #f59e0b;
}

.rep-icon-sky {
    background: #f0f9ff;
    color: #0284c7;
}

.rep-icon-indigo {
    background: #eef2ff;
    color: #4f46e5;
}

.rep-kpi-main {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 10px;
}

.rep-kpi-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.1;
}

.rep-kpi-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
}

.tag-emerald {
    background: #ecfdf5;
    color: #065f46;
}

.tag-amber {
    background: #fffbeb;
    color: #92400e;
}

.tag-purple {
    background: #f5f3ff;
    color: #5b21b6;
}

.tag-sky {
    background: #f0f9ff;
    color: #075985;
}

.tag-indigo {
    background: #eef2ff;
    color: #3730a3;
}

.rep-kpi-progress {
    width: 100%;
    height: 6px;
    background: #f1f5f9;
    border-radius: 9999px;
    overflow: hidden;
    margin-bottom: 8px;
}

.rep-kpi-progress-bar {
    height: 100%;
    border-radius: 9999px;
    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.bg-bar-emerald {
    background: #10b981;
}

.bg-bar-amber {
    background: #f59e0b;
}

.bg-bar-purple {
    background: #8b5cf6;
}

.bg-bar-sky {
    background: #0ea5e9;
}

.bg-bar-indigo {
    background: #4f46e5;
}

.rep-kpi-sub-row {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding-top: 8px;
}

.rep-kpi-sub-highlight {
    font-size: 11.5px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
}

.rep-kpi-sub {
    font-size: 11px;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Compact Executive KPI Cards (Matching Reference) ─────────────────── */
.rep-kpi-card.rep-card-compact {
    background: #ffffff;
    border: 1px solid rgba(226, 232, 240, 0.9);
    border-radius: 16px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 14px -3px rgba(15, 23, 42, 0.05);
    transition: all 0.22s ease;
    min-height: 154px;
}

.rep-kpi-card.rep-card-compact:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

/* Card Top: Icon + Title + Chevron */
.rep-card-top {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 7px;
}

.rep-card-icon {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
}

.icon-blue {
    background: #eff6ff;
    color: #3b82f6;
}

.icon-amber {
    background: #fffbeb;
    color: #f59e0b;
}

.icon-purple {
    background: #f5f3ff;
    color: #8b5cf6;
}

.icon-green {
    background: #ecfdf5;
    color: #10b981;
}

.rep-card-head-txt {
    flex: 1 1;
    min-width: 0;
}

.rep-card-title {
    font-size: 12.5px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rep-card-sub {
    font-size: 10px;
    color: #94a3b8;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rep-card-arrow {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #f8fafc;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    flex-shrink: 0;
}

/* Value Row */
.rep-val-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.rep-split-val {
    display: flex;
    align-items: baseline;
    gap: 4px;
}

.val-accent {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 20px;
    font-weight: 800;
    line-height: 1;
}

.val-slash {
    font-size: 15px;
    color: #94a3b8;
    font-weight: 600;
}

.val-total {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 19px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1;
}

.rep-single-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 20px;
    font-weight: 800;
    line-height: 1;
}

.val-unit {
    font-size: 13px;
    font-weight: 600;
}

/* Pill Badges */
.rep-pill-badge {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 9999px;
    white-space: nowrap;
}

.pill-purple {
    background: #f5f3ff;
    color: #7c3aed;
}

.pill-amber {
    background: #fffbeb;
    color: #b45309;
}

/* Slim Bar */
.rep-slim-bar {
    width: 100%;
    height: 5px;
    background: #f1f5f9;
    border-radius: 9999px;
    overflow: hidden;
    margin-bottom: 7px;
}

.rep-slim-fill {
    height: 100%;
    border-radius: 9999px;
    transition: width 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Bottom Tinted Box */
.rep-bottom-box {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 6px 9px;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
}

.box-blue-tint {
    background: #f8fafc;
    border: 1px solid #f1f5f9;
}

.box-amber-tint {
    background: #fffdf5;
    border: 1px solid #fef3c7;
}

.box-purple-tint {
    background: #faf5ff;
    border: 1px solid #f3e8ff;
}

.box-icon-wrap {
    font-size: 13px;
    line-height: 1;
    flex-shrink: 0;
}

.icon-wrap-green {
    color: #10b981;
}

.icon-wrap-amber {
    color: #f59e0b;
}

.icon-wrap-purple {
    color: #8b5cf6;
}

.box-text-wrap {
    flex: 1 1;
    min-width: 0;
    position: relative;
    z-index: 1;
}

.box-main-txt {
    font-size: 11px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.box-sub-txt {
    font-size: 9.5px;
    color: #94a3b8;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.box-corner-watermark {
    position: absolute;
    right: -10px;
    bottom: -10px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    opacity: 0.3;
    pointer-events: none;
}

.watermark-blue {
    background: radial-gradient(circle, #3b82f6 0%, transparent 70%);
}

.watermark-amber {
    background: radial-gradient(circle, #f59e0b 0%, transparent 70%);
}

.watermark-purple {
    background: radial-gradient(circle, #8b5cf6 0%, transparent 70%);
}

/* Card 4 (Status & Velocity) Compact Layout */
.rep-card-v4 {
    display: flex;
    flex-direction: column;
}

.v4-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: auto;
}

.v4-sub-section {
    display: flex;
    flex-direction: column;
}

.v4-head-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3px;
}

.v4-label {
    font-size: 10px;
    font-weight: 700;
    color: #1e293b;
    display: flex;
    align-items: center;
}

.v4-phases-tag {
    font-size: 9.5px;
    font-weight: 600;
    color: #64748b;
    background: #f1f5f9;
    padding: 1px 5px;
    border-radius: 4px;
}

.v4-rate-tag {
    font-size: 9.5px;
    font-weight: 700;
    color: #065f46;
    background: #ecfdf5;
    padding: 1px 5px;
    border-radius: 4px;
    border: 1px solid #a7f3d0;
}

.v4-track {
    display: flex;
    height: 5px;
    width: 100%;
    border-radius: 9999px;
    overflow: hidden;
    background: #f1f5f9;
    margin-bottom: 4px;
    gap: 2px;
}

.v4-seg {
    height: 100%;
    transition: width 0.6s ease;
}

.v4-seg.seg-done {
    background: #10b981;
}

.v4-seg.seg-active {
    background: #f59e0b;
}

.v4-seg.seg-queued {
    background: #cbd5e1;
}

.v4-pills-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 1px;
}

.v4-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: transparent;
    border: none;
    padding: 0;
    font-size: 10px;
    font-weight: 600;
    white-space: nowrap;
}

.v4-pill.pill-done {
    background: transparent;
    border: none;
    color: #059669;
}

.v4-pill.pill-active {
    background: transparent;
    border: none;
    color: #d97706;
}

.v4-pill.pill-queued {
    background: transparent;
    border: none;
    color: #64748b;
}

.v4-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
}

.v4-dot.dot-green {
    background: #10b981;
}

.v4-dot.dot-amber {
    background: #f59e0b;
}

.v4-dot.dot-blue {
    background: #0ea5e9;
}

.v4-meta-row {
    font-size: 9.5px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    margin-top: 1px;
}

.v4-hrs-txt {
    font-weight: 600;
    color: #334155;
}

/* ── Analytics Breakdown Section ───────────────────────────────────────── */
.reports-analytics-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 24px;
}

@media (max-width: 992px) {
    .reports-analytics-row {
        grid-template-columns: 1fr;
    }
}

.analytics-panel {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 22px 24px;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
}

.panel-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.panel-title i {
    color: #6366f1;
    font-size: 16px;
}

.panel-badge {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    background: #f1f5f9;
    padding: 3px 8px;
    border-radius: 6px;
}

/* Distribution Segment Bar */
.multi-segment-track {
    display: flex;
    height: 10px;
    width: 100%;
    border-radius: 9999px;
    overflow: hidden;
    background: #f1f5f9;
    margin-bottom: 18px;
    gap: 2px;
}

.segment-item {
    height: 100%;
    transition: width 0.8s ease;
}

.segment-completed {
    background: #10b981;
}

.segment-in-progress {
    background: #f59e0b;
}

.segment-not-started {
    background: #cbd5e1;
}

.legend-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.legend-item {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
}

.legend-dot-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 4px;
}

.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.dot-green {
    background: #10b981;
}

.dot-amber {
    background: #f59e0b;
}

.dot-gray {
    background: #94a3b8;
}

.legend-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
}

.legend-sub {
    font-size: 10.5px;
    color: #94a3b8;
}

/* Timeline & Velocity Card */
.task-velocity-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
}

.velocity-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 16px;
}

.velocity-box-title {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 4px;
}

.velocity-box-value {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
}

.timeline-info-strip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 10px 14px;
    font-size: 12px;
    color: #475569;
}

.timeline-info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
}

.timeline-info-item i {
    color: #6366f1;
}

/* ── Milestones Detailed Table Card ────────────────────────────────────── */
.reports-table-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    margin-bottom: 30px;
}

.reports-table-header {
    padding: 18px 22px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
}

.table-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.table-header-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.table-count-badge {
    background: #eef2ff;
    color: #4f46e5;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 9999px;
}

.table-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

/* Status Filter Tabs */
.status-filter-pills {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    gap: 2px;
}

.filter-tab-pill {
    background: transparent;
    border: none;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    gap: 5px;
}

.filter-tab-pill:hover {
    color: #0f172a;
}

.filter-tab-pill.active {
    background: #ffffff;
    color: #4f46e5;
    font-weight: 700;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tab-pill-count {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 9999px;
    background: #e2e8f0;
    color: #475569;
}

.filter-tab-pill.active .tab-pill-count {
    background: #eef2ff;
    color: #4f46e5;
}

/* Search Box */
.report-search-box {
    position: relative;
    width: 220px;
}

.report-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.report-search-input {
    width: 100%;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding-left: 30px;
    padding-right: 28px;
    font-size: 12.5px;
    background: #f8fafc;
    color: #0f172a;
    transition: all 0.2s ease;
}

.report-search-input:focus {
    outline: none;
    background: #ffffff;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.report-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 12px;
    color: #94a3b8;
    cursor: pointer;
    padding: 0;
}

/* ── Modern Table Styles ───────────────────────────────────────────────── */
.table-reports-custom {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    margin: 0;
}

.table-reports-custom thead {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.table-reports-custom th {
    padding: 13px 18px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
    border: none;
    white-space: nowrap;
}

.table-reports-custom td {
    padding: 15px 18px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
}

.table-reports-custom tbody tr {
    transition: background-color 0.15s ease;
}

.table-reports-custom tbody tr:hover {
    background-color: #f8fafc;
}

.table-reports-custom tbody tr:last-child td {
    border-bottom: none;
}

.col-idx {
    font-weight: 700;
    color: #94a3b8;
    width: 44px;
}

.milestone-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}

.milestone-icon-avatar {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #f1f5f9;
    color: #6366f1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
}

.milestone-title-text {
    font-weight: 600;
    color: #0f172a;
    font-size: 13.5px;
}

.date-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #475569;
    font-size: 12.5px;
    font-weight: 500;
    white-space: nowrap;
}

.date-pill i {
    color: #94a3b8;
    font-size: 12px;
}

.tasks-count-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    white-space: nowrap;
}

.tasks-count-pill i {
    color: #6366f1;
}

/* Progress Cell */
.progress-cell-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 150px;
}

.progress-track-custom {
    flex: 1 1;
    height: 7px;
    background: #f1f5f9;
    border-radius: 9999px;
    overflow: hidden;
}

.progress-fill-custom {
    height: 100%;
    border-radius: 9999px;
    transition: width 0.6s ease;
}

.progress-pct-text {
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
    min-width: 38px;
    text-align: right;
}

/* Status Badges */
.rep-badge-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 11.5px;
    font-weight: 700;
    white-space: nowrap;
}

.badge-status-completed {
    background: #ecfdf5;
    color: #065f46;
    border: 1px solid #a7f3d0;
}

.badge-status-inprogress {
    background: #fffbeb;
    color: #b45309;
    border: 1px solid #fde68a;
}

.badge-status-notstarted {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
}

/* Empty State */
.table-empty-wrap {
    padding: 50px 20px;
    text-align: center;
    color: #64748b;
}

.table-empty-icon {
    font-size: 42px;
    color: #cbd5e1;
    margin-bottom: 12px;
}

.table-empty-title {
    font-size: 15px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 4px;
}

.table-empty-sub {
    font-size: 13px;
    color: #94a3b8;
    margin-bottom: 16px;
}

/* ── Print Stylesheet ─────────────────────────────────────────────────── */
@media print {
    @page {
        margin: 12mm 15mm;
        size: auto;
    }

    body {
        background: #ffffff !important;
        color: #000000 !important;
    }

    .dash-sidebar,
    .dash-header,
    .btn-report-action,
    .reports-hero-actions,
    .status-filter-pills,
    .report-search-box,
    .sidebar-mobile-backdrop {
        display: none !important;
    }

    .dashboard-wrapper {
        display: block !important;
        min-height: auto !important;
    }

    .dash-main {
        margin-left: 0 !important;
        padding: 0 !important;
        width: 100% !important;
    }

    .rep-kpi-card,
    .analytics-panel,
    .reports-table-card {
        box-shadow: none !important;
        border: 1px solid #cbd5e1 !important;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .reports-kpi-grid {
        grid-template-columns: repeat(4, 1fr) !important;
    }

    .table-reports-custom th,
    .table-reports-custom td {
        padding: 8px 10px !important;
        font-size: 11px !important;
    }
}

.milestone-table-row {
    transition: background-color 0.15s ease;
}

.milestone-table-row:hover td {
    background-color: #f1f5f9 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;IAC7D,cAAc;IACd,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,iDAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,4EAA4E;AAC5E;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;IAClD,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,kDAAkD;IAClD,qBAAqB;AACzB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,6EAA6E;AAC7E;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA,4EAA4E;AAC5E;IACI;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;;;;;;;QAOI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;;;QAGI,2BAA2B;QAC3B,oCAAoC;QACpC,wBAAmB;QAAnB,mBAAmB;IACvB;;IAEA;QACI,gDAAgD;IACpD;;IAEA;;QAEI,4BAA4B;QAC5B,0BAA0B;IAC9B;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["/* ==========================================================================\n   PROJECT PERFORMANCE & ANALYTICS REPORTS STYLING\n   Enterprise Linear/Stripe/Vercel Aesthetic\n   ========================================================================== */\n\n/* ── Hero / Overview Header ────────────────────────────────────────────── */\n.reports-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.reports-hero-left {\n    flex: 1;\n    min-width: 280px;\n}\n\n.reports-badge-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.reports-hero-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.5px;\n}\n\n.reports-hero-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px 0;\n    max-width: 600px;\n    line-height: 1.5;\n}\n\n.reports-meta-chips {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.report-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.report-chip i {\n    font-size: 12px;\n    color: #6366f1;\n}\n\n.report-chip-status {\n    background: #ecfdf5;\n    border-color: #a7f3d0;\n    color: #065f46;\n}\n\n.pulse-dot-green {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #10b981;\n    display: inline-block;\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n    animation: pulseGlow 1.8s infinite;\n}\n\n@keyframes pulseGlow {\n    0% {\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n    }\n\n    70% {\n        box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n    }\n}\n\n/* ── Hero Actions ──────────────────────────────────────────────────────── */\n.reports-hero-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.btn-report-action {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.btn-report-action:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n}\n\n.btn-report-action.btn-primary-gradient {\n    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n    color: #ffffff;\n    border: 1px solid #4338ca;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);\n}\n\n.btn-report-action.btn-primary-gradient:hover {\n    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%);\n    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);\n    transform: translateY(-1px);\n}\n\n/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */\n.reports-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n@media (max-width: 1200px) {\n    .reports-kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 640px) {\n    .reports-kpi-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.rep-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    transition: all 0.25s ease;\n}\n\n.rep-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.rep-kpi-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.rep-kpi-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: #64748b;\n}\n\n.rep-kpi-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.rep-icon-purple {\n    background: #f5f3ff;\n    color: #7c3aed;\n}\n\n.rep-icon-emerald {\n    background: #ecfdf5;\n    color: #10b981;\n}\n\n.rep-icon-amber {\n    background: #fffbeb;\n    color: #f59e0b;\n}\n\n.rep-icon-sky {\n    background: #f0f9ff;\n    color: #0284c7;\n}\n\n.rep-icon-indigo {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.rep-kpi-main {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.rep-kpi-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.1;\n}\n\n.rep-kpi-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n}\n\n.tag-emerald {\n    background: #ecfdf5;\n    color: #065f46;\n}\n\n.tag-amber {\n    background: #fffbeb;\n    color: #92400e;\n}\n\n.tag-purple {\n    background: #f5f3ff;\n    color: #5b21b6;\n}\n\n.tag-sky {\n    background: #f0f9ff;\n    color: #075985;\n}\n\n.tag-indigo {\n    background: #eef2ff;\n    color: #3730a3;\n}\n\n.rep-kpi-progress {\n    width: 100%;\n    height: 6px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    overflow: hidden;\n    margin-bottom: 8px;\n}\n\n.rep-kpi-progress-bar {\n    height: 100%;\n    border-radius: 9999px;\n    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.bg-bar-emerald {\n    background: #10b981;\n}\n\n.bg-bar-amber {\n    background: #f59e0b;\n}\n\n.bg-bar-purple {\n    background: #8b5cf6;\n}\n\n.bg-bar-sky {\n    background: #0ea5e9;\n}\n\n.bg-bar-indigo {\n    background: #4f46e5;\n}\n\n.rep-kpi-sub-row {\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding-top: 8px;\n}\n\n.rep-kpi-sub-highlight {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #1e293b;\n    display: flex;\n    align-items: center;\n}\n\n.rep-kpi-sub {\n    font-size: 11px;\n    color: #64748b;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Compact Executive KPI Cards (Matching Reference) ─────────────────── */\n.rep-kpi-card.rep-card-compact {\n    background: #ffffff;\n    border: 1px solid rgba(226, 232, 240, 0.9);\n    border-radius: 16px;\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 4px 14px -3px rgba(15, 23, 42, 0.05);\n    transition: all 0.22s ease;\n    min-height: 154px;\n}\n\n.rep-kpi-card.rep-card-compact:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n/* Card Top: Icon + Title + Chevron */\n.rep-card-top {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    margin-bottom: 7px;\n}\n\n.rep-card-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 9px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    flex-shrink: 0;\n}\n\n.icon-blue {\n    background: #eff6ff;\n    color: #3b82f6;\n}\n\n.icon-amber {\n    background: #fffbeb;\n    color: #f59e0b;\n}\n\n.icon-purple {\n    background: #f5f3ff;\n    color: #8b5cf6;\n}\n\n.icon-green {\n    background: #ecfdf5;\n    color: #10b981;\n}\n\n.rep-card-head-txt {\n    flex: 1;\n    min-width: 0;\n}\n\n.rep-card-title {\n    font-size: 12.5px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.rep-card-sub {\n    font-size: 10px;\n    color: #94a3b8;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.rep-card-arrow {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #f8fafc;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 9px;\n    flex-shrink: 0;\n}\n\n/* Value Row */\n.rep-val-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n\n.rep-split-val {\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n}\n\n.val-accent {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1;\n}\n\n.val-slash {\n    font-size: 15px;\n    color: #94a3b8;\n    font-weight: 600;\n}\n\n.val-total {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 19px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1;\n}\n\n.rep-single-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1;\n}\n\n.val-unit {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n/* Pill Badges */\n.rep-pill-badge {\n    font-size: 10px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 9999px;\n    white-space: nowrap;\n}\n\n.pill-purple {\n    background: #f5f3ff;\n    color: #7c3aed;\n}\n\n.pill-amber {\n    background: #fffbeb;\n    color: #b45309;\n}\n\n/* Slim Bar */\n.rep-slim-bar {\n    width: 100%;\n    height: 5px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    overflow: hidden;\n    margin-bottom: 7px;\n}\n\n.rep-slim-fill {\n    height: 100%;\n    border-radius: 9999px;\n    transition: width 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Bottom Tinted Box */\n.rep-bottom-box {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 6px 9px;\n    border-radius: 10px;\n    position: relative;\n    overflow: hidden;\n    margin-top: auto;\n}\n\n.box-blue-tint {\n    background: #f8fafc;\n    border: 1px solid #f1f5f9;\n}\n\n.box-amber-tint {\n    background: #fffdf5;\n    border: 1px solid #fef3c7;\n}\n\n.box-purple-tint {\n    background: #faf5ff;\n    border: 1px solid #f3e8ff;\n}\n\n.box-icon-wrap {\n    font-size: 13px;\n    line-height: 1;\n    flex-shrink: 0;\n}\n\n.icon-wrap-green {\n    color: #10b981;\n}\n\n.icon-wrap-amber {\n    color: #f59e0b;\n}\n\n.icon-wrap-purple {\n    color: #8b5cf6;\n}\n\n.box-text-wrap {\n    flex: 1;\n    min-width: 0;\n    position: relative;\n    z-index: 1;\n}\n\n.box-main-txt {\n    font-size: 11px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.box-sub-txt {\n    font-size: 9.5px;\n    color: #94a3b8;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.box-corner-watermark {\n    position: absolute;\n    right: -10px;\n    bottom: -10px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    opacity: 0.3;\n    pointer-events: none;\n}\n\n.watermark-blue {\n    background: radial-gradient(circle, #3b82f6 0%, transparent 70%);\n}\n\n.watermark-amber {\n    background: radial-gradient(circle, #f59e0b 0%, transparent 70%);\n}\n\n.watermark-purple {\n    background: radial-gradient(circle, #8b5cf6 0%, transparent 70%);\n}\n\n/* Card 4 (Status & Velocity) Compact Layout */\n.rep-card-v4 {\n    display: flex;\n    flex-direction: column;\n}\n\n.v4-body {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: auto;\n}\n\n.v4-sub-section {\n    display: flex;\n    flex-direction: column;\n}\n\n.v4-head-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 3px;\n}\n\n.v4-label {\n    font-size: 10px;\n    font-weight: 700;\n    color: #1e293b;\n    display: flex;\n    align-items: center;\n}\n\n.v4-phases-tag {\n    font-size: 9.5px;\n    font-weight: 600;\n    color: #64748b;\n    background: #f1f5f9;\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n.v4-rate-tag {\n    font-size: 9.5px;\n    font-weight: 700;\n    color: #065f46;\n    background: #ecfdf5;\n    padding: 1px 5px;\n    border-radius: 4px;\n    border: 1px solid #a7f3d0;\n}\n\n.v4-track {\n    display: flex;\n    height: 5px;\n    width: 100%;\n    border-radius: 9999px;\n    overflow: hidden;\n    background: #f1f5f9;\n    margin-bottom: 4px;\n    gap: 2px;\n}\n\n.v4-seg {\n    height: 100%;\n    transition: width 0.6s ease;\n}\n\n.v4-seg.seg-done {\n    background: #10b981;\n}\n\n.v4-seg.seg-active {\n    background: #f59e0b;\n}\n\n.v4-seg.seg-queued {\n    background: #cbd5e1;\n}\n\n.v4-pills-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 1px;\n}\n\n.v4-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    background: transparent;\n    border: none;\n    padding: 0;\n    font-size: 10px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.v4-pill.pill-done {\n    background: transparent;\n    border: none;\n    color: #059669;\n}\n\n.v4-pill.pill-active {\n    background: transparent;\n    border: none;\n    color: #d97706;\n}\n\n.v4-pill.pill-queued {\n    background: transparent;\n    border: none;\n    color: #64748b;\n}\n\n.v4-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n}\n\n.v4-dot.dot-green {\n    background: #10b981;\n}\n\n.v4-dot.dot-amber {\n    background: #f59e0b;\n}\n\n.v4-dot.dot-blue {\n    background: #0ea5e9;\n}\n\n.v4-meta-row {\n    font-size: 9.5px;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-weight: 500;\n    margin-top: 1px;\n}\n\n.v4-hrs-txt {\n    font-weight: 600;\n    color: #334155;\n}\n\n/* ── Analytics Breakdown Section ───────────────────────────────────────── */\n.reports-analytics-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n@media (max-width: 992px) {\n    .reports-analytics-row {\n        grid-template-columns: 1fr;\n    }\n}\n\n.analytics-panel {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 22px 24px;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n}\n\n.panel-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 18px;\n}\n\n.panel-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n}\n\n.panel-title i {\n    color: #6366f1;\n    font-size: 16px;\n}\n\n.panel-badge {\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    background: #f1f5f9;\n    padding: 3px 8px;\n    border-radius: 6px;\n}\n\n/* Distribution Segment Bar */\n.multi-segment-track {\n    display: flex;\n    height: 10px;\n    width: 100%;\n    border-radius: 9999px;\n    overflow: hidden;\n    background: #f1f5f9;\n    margin-bottom: 18px;\n    gap: 2px;\n}\n\n.segment-item {\n    height: 100%;\n    transition: width 0.8s ease;\n}\n\n.segment-completed {\n    background: #10b981;\n}\n\n.segment-in-progress {\n    background: #f59e0b;\n}\n\n.segment-not-started {\n    background: #cbd5e1;\n}\n\n.legend-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.legend-item {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n}\n\n.legend-dot-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    margin-bottom: 4px;\n}\n\n.legend-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n}\n\n.dot-green {\n    background: #10b981;\n}\n\n.dot-amber {\n    background: #f59e0b;\n}\n\n.dot-gray {\n    background: #94a3b8;\n}\n\n.legend-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 16px;\n    font-weight: 800;\n    color: #0f172a;\n}\n\n.legend-sub {\n    font-size: 10.5px;\n    color: #94a3b8;\n}\n\n/* Timeline & Velocity Card */\n.task-velocity-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.velocity-box {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 12px 16px;\n}\n\n.velocity-box-title {\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    margin-bottom: 4px;\n}\n\n.velocity-box-value {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 18px;\n    font-weight: 800;\n    color: #0f172a;\n}\n\n.timeline-info-strip {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 10px 14px;\n    font-size: 12px;\n    color: #475569;\n}\n\n.timeline-info-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 500;\n}\n\n.timeline-info-item i {\n    color: #6366f1;\n}\n\n/* ── Milestones Detailed Table Card ────────────────────────────────────── */\n.reports-table-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    margin-bottom: 30px;\n}\n\n.reports-table-header {\n    padding: 18px 22px;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 14px;\n}\n\n.table-header-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.table-header-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 16px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n}\n\n.table-count-badge {\n    background: #eef2ff;\n    color: #4f46e5;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 9999px;\n}\n\n.table-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* Status Filter Tabs */\n.status-filter-pills {\n    display: flex;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 8px;\n    gap: 2px;\n}\n\n.filter-tab-pill {\n    background: transparent;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.filter-tab-pill:hover {\n    color: #0f172a;\n}\n\n.filter-tab-pill.active {\n    background: #ffffff;\n    color: #4f46e5;\n    font-weight: 700;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.tab-pill-count {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 9999px;\n    background: #e2e8f0;\n    color: #475569;\n}\n\n.filter-tab-pill.active .tab-pill-count {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n/* Search Box */\n.report-search-box {\n    position: relative;\n    width: 220px;\n}\n\n.report-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.report-search-input {\n    width: 100%;\n    height: 34px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    padding-left: 30px;\n    padding-right: 28px;\n    font-size: 12.5px;\n    background: #f8fafc;\n    color: #0f172a;\n    transition: all 0.2s ease;\n}\n\n.report-search-input:focus {\n    outline: none;\n    background: #ffffff;\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.report-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    font-size: 12px;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ── Modern Table Styles ───────────────────────────────────────────────── */\n.table-reports-custom {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    margin: 0;\n}\n\n.table-reports-custom thead {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.table-reports-custom th {\n    padding: 13px 18px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #64748b;\n    border: none;\n    white-space: nowrap;\n}\n\n.table-reports-custom td {\n    padding: 15px 18px;\n    vertical-align: middle;\n    border-bottom: 1px solid #f1f5f9;\n    color: #334155;\n}\n\n.table-reports-custom tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.table-reports-custom tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.table-reports-custom tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.col-idx {\n    font-weight: 700;\n    color: #94a3b8;\n    width: 44px;\n}\n\n.milestone-title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.milestone-icon-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: #f1f5f9;\n    color: #6366f1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.milestone-title-text {\n    font-weight: 600;\n    color: #0f172a;\n    font-size: 13.5px;\n}\n\n.date-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #475569;\n    font-size: 12.5px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.date-pill i {\n    color: #94a3b8;\n    font-size: 12px;\n}\n\n.tasks-count-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #334155;\n    white-space: nowrap;\n}\n\n.tasks-count-pill i {\n    color: #6366f1;\n}\n\n/* Progress Cell */\n.progress-cell-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 150px;\n}\n\n.progress-track-custom {\n    flex: 1;\n    height: 7px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    overflow: hidden;\n}\n\n.progress-fill-custom {\n    height: 100%;\n    border-radius: 9999px;\n    transition: width 0.6s ease;\n}\n\n.progress-pct-text {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0f172a;\n    min-width: 38px;\n    text-align: right;\n}\n\n/* Status Badges */\n.rep-badge-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border-radius: 9999px;\n    font-size: 11.5px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.badge-status-completed {\n    background: #ecfdf5;\n    color: #065f46;\n    border: 1px solid #a7f3d0;\n}\n\n.badge-status-inprogress {\n    background: #fffbeb;\n    color: #b45309;\n    border: 1px solid #fde68a;\n}\n\n.badge-status-notstarted {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n\n/* Empty State */\n.table-empty-wrap {\n    padding: 50px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.table-empty-icon {\n    font-size: 42px;\n    color: #cbd5e1;\n    margin-bottom: 12px;\n}\n\n.table-empty-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #334155;\n    margin-bottom: 4px;\n}\n\n.table-empty-sub {\n    font-size: 13px;\n    color: #94a3b8;\n    margin-bottom: 16px;\n}\n\n/* ── Print Stylesheet ─────────────────────────────────────────────────── */\n@media print {\n    @page {\n        margin: 12mm 15mm;\n        size: auto;\n    }\n\n    body {\n        background: #ffffff !important;\n        color: #000000 !important;\n    }\n\n    .dash-sidebar,\n    .dash-header,\n    .btn-report-action,\n    .reports-hero-actions,\n    .status-filter-pills,\n    .report-search-box,\n    .sidebar-mobile-backdrop {\n        display: none !important;\n    }\n\n    .dashboard-wrapper {\n        display: block !important;\n        min-height: auto !important;\n    }\n\n    .dash-main {\n        margin-left: 0 !important;\n        padding: 0 !important;\n        width: 100% !important;\n    }\n\n    .rep-kpi-card,\n    .analytics-panel,\n    .reports-table-card {\n        box-shadow: none !important;\n        border: 1px solid #cbd5e1 !important;\n        break-inside: avoid;\n    }\n\n    .reports-kpi-grid {\n        grid-template-columns: repeat(4, 1fr) !important;\n    }\n\n    .table-reports-custom th,\n    .table-reports-custom td {\n        padding: 8px 10px !important;\n        font-size: 11px !important;\n    }\n}\n\n.milestone-table-row {\n    transition: background-color 0.15s ease;\n}\n\n.milestone-table-row:hover td {\n    background-color: #f1f5f9 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
